module.exports = __webpack_public_path__ + "img/alle disciplines--white.f5241473.svg";